<span (click)="toggleCircle()">
    <mat-icon fontSet="{{ circleState }}" fontIcon="fa-circle" [style.color]="color"></mat-icon>
    {{ year }}
</span>
